var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70994 6.29C9.52217 6.10069 9.26658 5.9942 8.99994 5.9942C8.7333 5.9942 8.47771 6.10069 8.28994 6.29L3.28994 11.29C3.10063 11.4778 2.99414 11.7334 2.99414 12C2.99414 12.2666 3.10063 12.5222 3.28994 12.71L8.28994 17.71C8.47771 17.8993 8.7333 18.0058 8.99994 18.0058C9.26658 18.0058 9.52217 17.8993 9.70994 17.71C9.89925 17.5222 10.0057 17.2666 10.0057 17C10.0057 16.7334 9.89925 16.4778 9.70994 16.29L5.40994 12L9.70994 7.71C9.89925 7.52223 10.0057 7.26664 10.0057 7C10.0057 6.73336 9.89925 6.47777 9.70994 6.29ZM20.7099 11.29L15.7099 6.29C15.4563 6.03634 15.0866 5.93728 14.7401 6.03012C14.3936 6.12297 14.1229 6.39362 14.0301 6.74012C13.9372 7.08663 14.0363 7.45634 14.2899 7.71L18.5899 12L14.2899 16.29C14.1006 16.4778 13.9941 16.7334 13.9941 17C13.9941 17.2666 14.1006 17.5222 14.2899 17.71C14.4777 17.8993 14.7333 18.0058 14.9999 18.0058C15.2666 18.0058 15.5222 17.8993 15.7099 17.71L20.7099 12.71C20.8993 12.5222 21.0057 12.2666 21.0057 12C21.0057 11.7334 20.8993 11.4778 20.7099 11.29Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default ForwardRef;